import { render, staticRenderFns } from "./fans-tag-manager.vue?vue&type=template&id=631cbacc"
import script from "./fans-tag-manager.vue?vue&type=script&lang=js"
export * from "./fans-tag-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631cbacc')) {
      api.createRecord('631cbacc', component.options)
    } else {
      api.reload('631cbacc', component.options)
    }
    module.hot.accept("./fans-tag-manager.vue?vue&type=template&id=631cbacc", function () {
      api.rerender('631cbacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/components/fans-tag-manager.vue"
export default component.exports